import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Col, Container, Row} from 'react-bootstrap';

import {BaseService} from "../../../Services/Core/BaseService";

import {DocumentUtils} from "../../../Utils/DocumentUtils";
import {ForgotPasswordPopup} from "../../Common/ForgotPasswordPopup";
import {login} from "../../../Redux/Thunks/loginThunks";
import {VerificationComponent} from "../../Auth/VerificationComponent";

import {LoginComponent} from "../../Auth/LoginComponent";

import {StreamBankPageHeader} from "../../Common/StreamBankPageHeader";

export const LoginPage = (props) => {
    const loginState = useSelector(state => state.loginState);
    const [state, setState] = useState({displayForgotPassword: false});
    const dispatch = useDispatch();

    const attemptRedirect = () => {
        let url = DocumentUtils.GetQueryStringParameter("redirectUrl");

        if(url && BaseService.IS_AUTHENTICATED) {
            DocumentUtils.changePage(url);
        } else {
            DocumentUtils.changePage("/programs");
        }
    };

    return (
        <Container className={"sb-root-page sb-login-page"}>
            <div className="login-page">
                <StreamBankPageHeader
                    Title={"Login"}
                />
                <ForgotPasswordPopup
                    SuggestedEmail={loginState.fields.email}
                    Display={state.displayForgotPassword}
                    Close={() => setState({displayForgotPassword: false})}
                />
                <Row key={1}>
                    <Col xs={12} md={12}>
                        <h2>{loginState.title || 'Login'}</h2>
                        <hr />
                    </Col>
                </Row>
                <Row key={2}>
                    <Col xs={12} md={3} />
                    <Col xs={12} md={6}>
                        {
                            !loginState.isVerifying ?
                                <LoginComponent
                                    Login={() => dispatch(login(attemptRedirect, true))}
                                    ForgotPassword={() => setState({displayForgotPassword: true})}
                                /> :
                                <VerificationComponent OnSuccess={attemptRedirect} />
                        }
                    </Col>
                    <Col xs={12} md={3} />
                </Row>
            </div>
        </Container>
    );
};


